import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogService } from '../../../../../core/services/dialog.service';
import { InputsModule } from '../../../../common/inputs/inputs.module';
import { MatButtonModule } from '@angular/material/button';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'ling-enter-password-dialog',
  standalone: true,
  imports: [
    CommonModule,
    InputsModule,
    MatButtonModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  templateUrl: './enter-password-dialog.component.html',
  styleUrls: ['./enter-password-dialog.component.scss'],
})
export class EnterPasswordDialogComponent {
  constructor(private dialog: DialogService) {}

  password = new FormControl('', Validators.required);

  onContinue(): void {
    if (this.password.invalid) {
      return;
    }
    this.dialog.closeCurrent(this.password.value);
  }
}
